var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgActionRequired = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#71717A",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M12 14.5V6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#71717A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M12 18v.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "current",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25Z"
})));
export { SvgActionRequired as ReactComponent };
export default __webpack_public_path__ + "edf2ffd4812ccbc231050c9fd097168a.svg";